module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"explicative_video":"How to use this screen"},"fr":{"explicative_video":"Comment utiliser cet écran"},"de":{"explicative_video":"So verwenden Sie diesen Bildschirm"}}')
  delete Component.options._Ctor
}
